import React, { useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import TotalCase from "../../../images/totalCase.svg";
import GreenCase from "../../../images/case_green.svg";
import Combined from "../../../images/combined.svg";
import Rejected from "../../../images/rejected_case.svg";
import TotalTrey from "../../../images/total_tray.svg";
import Carts from "../../../images/total_cart.svg";
import TreyRed from "../../../images/trey_red.svg";
import KgGreen from "../../../images/kg_green.svg";
import KgRed from "../../../images/kg_rejected.svg";
import OrangeTrey from "../../../images/tray_orange.svg";
import { Card, Col, Row } from "react-bootstrap";
import Button from "../../../components/shared/buttons/button";
import "./processing.css";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import ProcessingModal from "./ProcessingModal";
import WasteLogModal from "./WasteLogModal";
import { useGetProcessingSummaryQuery } from "../dashboard/processingApi";
import {
  useGetShiftDataQuery,
  useSearchEveningShiftDataQuery,
  useSearchMorningShiftDataQuery,
} from "./processingMenuApi";
import NoDataFound from "../../../components/shared/noDataFound/NoDataFound";
import { EditSvg } from "../../../svgFiles/EditSvg";
import EditProcessingModal from "./EditProcessingModal";
import TimeModal from "./TimeModal";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment-timezone";
import { formatDateAndTime, getAppTz, getCurrentDate } from "../../../helpers/Utils";
import { DEFAULT_DATETIME_FORMAT, PROJECT_DATE_FORMAT } from "../../../helpers/constants";
import toast from "react-hot-toast";

const Processing = () => {
  const [modalMode, setModalMode] = useState("add");
  const [showWaste, setShowWaste] = useState(false);
  const [wasteData, setWasteData] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const [editRecord, setEditRecord] = useState(false);
  const [timeRecord, setTimeRecord] = useState(false);
  const [showModal, setShowModal] = useState(false);  
  const currentDate = getCurrentDate('YYYY-MM-DD');
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("waste_return");
  const [summaryTab, setsummaryTab] = useState("processing");
  const { data: summaryData } = useGetProcessingSummaryQuery({
    tab: summaryTab,
    date,
  });
  const { data: morningShiftData } = useSearchMorningShiftDataQuery({ date });

  const { data: eveningShiftData } = useSearchEveningShiftDataQuery({ date });
  const { data: shift } = useGetShiftDataQuery({ date });
  const { _t } = useTranslator();
  const isCurrentDateShift = currentDate === date;

  const getShiftTimeRange = (shiftItem) => {
    if (!shiftItem?.start_time || !shiftItem?.end_time) {
      return null;
    }

    const timezone = getAppTz();
    
    const startUtc = moment.utc(
      `${shiftItem.start_time}`,
      ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"]
    );
    let endUtc = moment.utc(
      `${shiftItem.end_time}`,
      ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"]
    );

    if (!startUtc.isValid() || !endUtc.isValid()) {
      return `${shiftItem.start_time?.slice(0, 5)} To ${shiftItem.end_time?.slice(0, 5)}`;
    }

    // If end time is <= start time, treat it as next day (overnight shift).
    if (endUtc.isSameOrBefore(startUtc)) {
      endUtc = endUtc.add(1, "day");
    }

    const startInUserTz = startUtc.clone().tz(timezone).format(DEFAULT_DATETIME_FORMAT);
    const endInUserTz = endUtc.clone().tz(timezone).format(DEFAULT_DATETIME_FORMAT);

    return `${startInUserTz} To ${endInUserTz}`;
  };

  // const morningShiftTime = shift?.data?.find(
  //   (shift) => shift.name === "Morning Shift"
  // );

  // const eveningShiftTime = shift?.data?.find(
  //   (shift) => shift.name === "Evening Shift"
  // );


  const morningShiftTime = shift?.data?.find(
  (shift) => shift.name === "Morning Shift"
);

const eveningShiftTime = shift?.data?.find(
  (shift) => shift.name === "Evening Shift"
);



  const { data: summaryWasteData } = useGetProcessingSummaryQuery({
    date,
    tab,
  });
  const listItems = [
    {
      label: _t("cases_enter", "Cases Enter in processing"),
      value: summaryData?.data.total_cases_entered_in_processing,
      icon: TotalCase,
    },
    {
      label: _t("cases_processed", "Cases Processed"),
      value: summaryData?.data.total_cases_processed,
      icon: GreenCase,
    },
    {
      label: _t("cases_combined_label", "Cases Combined"),
      value: summaryData?.data.total_cases_combined,
      icon: Combined,
    },
    {
      label: _t("cases_rejected", "Cases Rejected"),
      value: summaryData?.data.total_cases_rejected,
      icon: Rejected,
    },
    {
      label: _t("total_carts", "Total Carts"),
      value: summaryData?.data.total_carts,
      icon: Carts,
    },
/*     {
      label: _t("cases_per_trey", "Cases Per Trey"),
      value: summaryData?.data?.cases_per_trey,
      icon: TotalTrey,
    }, */
    {
      label: _t("total_striped_treys", "Total Strips Treys"),
      value: summaryData?.data.total_striped_treys,
      icon: OrangeTrey,
    },
    {
      label: _t("total_cheek_treys", "Total Cheek Treys"),
      value: summaryData?.data.total_cheeks_treys,
      icon: OrangeTrey,
    },
    {
      label: _t("tapitas_treys", "Total Tapitas Treys"),
      value: summaryData?.data.total_tapitas_treys,
      icon: OrangeTrey,
    },
  ];
  const wasteListItems = [
    {
      label: _t("total_kg_returned", "Total KG Returned"),
      value: summaryWasteData?.data.total_kg_returned,
      icon: KgGreen,
    },
    {
      label: _t("total_kg_waste", "Total KG Waste"),
      value: summaryWasteData?.data.total_kg_waste,
      icon: KgRed,
    },
    {
      label: _t("total_case_waste", "Total Case Waste"),
      value: summaryWasteData?.data.case_waste,
      icon: Rejected,
    },
    {
      label: _t("total_trey_waste", "Total Trey Waste"),
      value: summaryWasteData?.data.trey_waste,
      icon: TreyRed,
    },
  ];

  const handleMorningRecord = () => {
    setAddRecord(true);
    setModalMode("addMorning");
    setSelectedRecord(morningData);
    setShowModal(true);
  };
  const handleEditMorning = (row) => {
    if (!isCurrentDateShift) {
      toast.error(
        _t(
          "edit_only_current_shift_data",
          "Only current date shift data can be edited."
        )
      );
      return;
    }

    // console.log(`Editing Morning`);
    setEditRecord(true);
    setSelectedRecordId(row[0].value);
    setSelectedRecord(row);
    setModalMode("editMorning");
    setShowModal(true);
  };
  const handleEditEvening = (row) => {
    if (!isCurrentDateShift) {
      toast.error(
        _t(
          "edit_only_current_shift_data",
          "Only current date shift data can be edited."
        )
      );
      return;
    }

    setEditRecord(true);
    setSelectedRecord(row);
    setSelectedRecordId(row[0].value);
    setModalMode("editEvening");
    setShowModal(true);
  };
  const handleEveningRecord = () => {
    setAddRecord(true);
    setModalMode("addEvening");
    setSelectedRecord(eveningData);
    setShowModal(true);
  };

  const morningData = morningShiftData?.data?.data
    ? morningShiftData.data.data.map((item) => [
        { label: _t("record_id"), value: item.id, key: "record_id" },
        {
          label: _t("fruit_type", "Fruit Type"),
          value: item.fruit_type,
          key: "fruit_type",
        },
        {
          label: _t("cases_processed", "Cases Processed"),
          value: item.cases_processed,
          key: "cases_processed",
        },
        {
          label: _t("cheeks_treys", "Cheeks Treys"),
          value: item.cheeks_treys,
          key: "cheeks_treys",
        },
        {
          label: _t("striped_treys", "Striped Treys"),
          value: item.striped_treys,
          key: "striped_treys",
        },
        {
          label: _t("tapitas_treys", "Tapitas Treys"),
          value: item.tapitas_treys,
          key: "tapitas_treys",
        },
        {
          label: _t("total_treys", "Total Treys"),
          value: item.total_treys,
          key: "total_treys",
        },
        {
          label: _t("carts", "Carts"),
          value: item.carts,
          key: "carts",
        },
        {
          label: _t("number_of_peelers", "Number Of Peelers"),
          value: item.number_of_peelers,
          key: "number_of_peelers",
        },
      ])
    : [];

  const eveningData = eveningShiftData?.data?.data
    ? eveningShiftData.data.data.map((item) => [
        { label: _t("record_id"), value: item.id, key: "record_id" },
        {
          label: _t("fruit_type", "Fruit Type"),
          value: item.fruit_type,
          key: "fruit_type",
        },
        {
          label: _t("cases_processed", "Cases Processed"),
          value: item.cases_processed,
          key: "cases_processed",
        },
        {
          label: _t("cheeks_treys", "Cheeks Treys"),
          value: item.cheeks_treys,
          key: "cheeks_treys",
        },
        {
          label: _t("striped_treys", "Striped Treys"),
          value: item.striped_treys,
          key: "striped_treys",
        },
        {
          label: _t("tapitas_treys", "Tapitas Treys"),
          value: item.tapitas_treys,
          key: "tapitas_treys",
        },
        {
          label: _t("total_treys", "Total Treys"),
          value: item.total_treys,
          key: "total_treys",
        },
        { label: _t("carts", "Carts"), value: item.carts, key: "carts" },
        {
          label: _t("cases_combined_label", "Cases Combined"),
          value: item.cases_combined,
          key: "cases_combined",
        },
        {
          label: _t("cases_returned", "Cases Returned"),
          value: item.cases_returned,
          key: "cases_returned",
        },
        {
          label: _t("cases_returned_total_weight", "Cases Returned Weight"),
          value: item.cases_returned_total_weight,
          key: "cases_returned_total_weight",
        },
        {
          label: _t("waste_cases", "Waste Cases"),
          value: item.waste_cases,
          key: "waste_cases",
        },
         {
          label: _t("waste_cases_weight", "Waste Cases Weight (kg)"),
          value: item.waste_cases_weight,
          key: "waste_cases_weight",
        },
        {
          label: _t("number_of_peelers", "Number Of Peelers"),
          value: item.number_of_peelers,
          key: "number_of_peelers",
        },
      ])
    : [];

  const handleAddwaste = () => {
    setShowWaste(true);
    setWasteData(summaryWasteData?.data);
  };
  const handleTimeShift = (mode, data) => {
    if(typeof data !== "undefined" && typeof data?.id !== "undefined"){
      setTimeRecord(true);
      setModalMode(mode);
      setSelectedRecord(data);
      setShowModal(true);
    }
  };
  const InfoCard = ({
    label,
    value,
    row,
    handleEdit,
    disabled = false,
  }) => {
    const showEditIcon = label === _t("fruit_type", "Fruit Type");

    return (
      <>
        <Card className="mb-3 shadow-sm">
          <Card.Body className="infocard d-flex justify-content-between align-items-center">
            <div>
              <h5 className="subtitle">{_t(label, label)}</h5>
              <p className="value mb-0">{value}</p>
            </div>
            {/* && currentDate === date */}
            {showEditIcon && !disabled && (
              <span
                className="cursor-pointer pe-2"
                onClick={() => handleEdit(row)}
              >
                <EditSvg color={"#667085"} />
              </span>
            )}
          </Card.Body>
        </Card>
      </>
    );
  };

  return (
    <div>
      {addRecord && (
        <ProcessingModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
          date={date}
        />
      )}
      {editRecord && (
        <EditProcessingModal
          show={showModal}
          setShow={setEditRecord}
          mode={modalMode}
          record={selectedRecord}
          recordId={selectedRecordId}
          date={date}
        />
      )}
      {timeRecord && (
        <TimeModal
          show={showModal}
          setShow={setTimeRecord}
          mode={modalMode}
          record={selectedRecord}
          date={date}
        />
      )}
      {showWaste && (
        <WasteLogModal
          show={showWaste}
          setShow={setShowWaste}
          data={wasteData}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("processing_title", "Processing Overview")}
          </h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date, PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <div className="processing-shift-section">
        <h6 className="shift-log-title">{_t("shift_log.title", "Shift Log")}</h6>

        <div className="gap-2 overviewcard processing-shift-grid">
          <Row>
            <Col lg={6}>
              <div className="dash_card h-100 processing-shift-card">
                <div className="d-flex justify-content-between align-items-center dash_header processing-shift-header">
                  <div className="card_heading processing-shift-meta">
                    <h3 className="mb-0">{_t("morning_shift", "Morning Shift")}</h3>
                    <div className="shift_row">
                      <span className="shift-timing-label">{_t("shift_hours", "Shift hours:")}</span>
                      <div className="shift_badge_group">
                        <span className="shift">
                          {shift?.data?.length > 0
                            ? getShiftTimeRange(morningShiftTime)
                            : _t("loading", "Loading...")}
                        </span>
                        {(currentDate === date && shift?.data?.length > 0) && (
                          <span
                            className="cursor-pointer shift_edit"
                            title={_t("edit_shift_time", "Edit shift timings")}
                            onClick={() => handleTimeShift("morning", morningShiftTime)}
                          >
                            <EditSvg widthSize="15" heightSize="15" />
                          </span>
                        )}
                      </div>
                    </div>
                    <p className="shift-timing-hint">
                      {_t("shift_timing_hint", "Data entries are accepted within this time window.")}
                    </p>
                  </div>
                  {morningData.length != 2 && (
                    <Button
                      size="xs"
                      className="processing-shift-btn"
                      label={_t("add_data", "Add Data")}
                      icon={PlusSvg}
                      onClick={handleMorningRecord}
                    />
                  )}
                </div>
                <div className="p-3 processing-shift-body">
                  <Row>
                    {morningData.length > 1 ? (
                      morningData.map((data, index) => (
                        <Col
                          lg={6}
                          key={index}
                          className={index === 0 ? "border-end" : ""}
                        >
                          <Row>
                            {data.map(
                              (item) =>
                                item.label != "record_id" && (
                                  <Col lg={12} key={item.label}>
                                    <InfoCard
                                      label={item.label}
                                      value={item.value}
                                      handleEdit={() => handleEditMorning(data)}
                                      row={data}
                                      disabled={!isCurrentDateShift}
                                    />
                                  </Col>
                                )
                            )}
                          </Row>
                        </Col>
                      ))
                    ) : morningData.length > 0 ? (
                      morningData.map((data, index) => (
                        <Row key={index}>
                          {data.map(
                            (item) =>
                              item.label != "record_id" && (
                                <Col lg={6} key={item.label}>
                                  <InfoCard
                                    label={item.label}
                                    value={item.value}
                                    handleEdit={() => handleEditMorning(data)}
                                    row={data}
                                    disabled={!isCurrentDateShift}
                                  />
                                </Col>
                              )
                          )}
                        </Row>
                      ))
                    ) : (
                      <NoDataFound />
                    )}
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="dash_card h-100 processing-shift-card">
                <div className="d-flex justify-content-between align-items-center dash_header processing-shift-header">
                  <div className="card_heading processing-shift-meta">
                    <h3 className="mb-0">{_t("evening_shift", "Evening Shift")}</h3>
                    <div className="shift_row">
                      <span className="shift-timing-label">{_t("shift_hours", "Shift hours:")}</span>
                      <div className="shift_badge_group">
                        <span className="shift">
                          {shift?.data?.length > 0
                            ? getShiftTimeRange(eveningShiftTime)
                            : _t("loading", "Loading...")}
                        </span>
                        {(currentDate === date && shift?.data?.length > 0) && (
                          <span
                            className="cursor-pointer shift_edit"
                            title={_t("edit_shift_time", "Edit shift timings")}
                            onClick={() => handleTimeShift("evening", eveningShiftTime)}
                          >
                            <EditSvg widthSize="15" heightSize="15" />
                          </span>
                        )}
                      </div>
                    </div>
                    <p className="shift-timing-hint">
                      {_t("shift_timing_hint", "Data entries are accepted within this time window.")}
                    </p>
                  </div>
                  {eveningData.length != 2 && (
                    <Button
                      size="xs"
                      className="processing-shift-btn"
                      label={_t("add_data", "Add Data")}
                      icon={PlusSvg}
                      onClick={handleEveningRecord}
                    />
                  )}
                </div>
                <div className="p-3 processing-shift-body">
                  <Row>
                    {eveningData.length > 1 ? (
                      eveningData.map((data, index) => (
                        <Col
                          lg={6}
                          key={index}
                          className={index === 0 ? "border-end" : ""}
                        >
                          <Row>
                            {data.map(
                              (item) =>
                                item.label != "record_id" && (
                                  <Col lg={12} key={item.label}>
                                    <InfoCard
                                      label={item.label}
                                      value={item.value}
                                      handleEdit={() => handleEditEvening(data)}
                                      row={data}
                                      disabled={!isCurrentDateShift}
                                    />
                                  </Col>
                                )
                            )}
                          </Row>
                        </Col>
                      ))
                    ) : eveningData.length > 0 ? (
                      eveningData.map((data, index) => (
                        <Row key={index}>
                          {data.map(
                            (item) =>
                              item.label != "record_id" && (
                                <Col lg={6} key={item.label}>
                                  <InfoCard
                                    label={item.label}
                                    value={item.value}
                                    handleEdit={() => handleEditEvening(data)}
                                    row={data}
                                    disabled={!isCurrentDateShift}
                                  />
                                </Col>
                              )
                          )}
                        </Row>
                      ))
                    ) : (
                      <NoDataFound />
                    )}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {/* <div className="overview cmn_card mt-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">Waste and Return Log</h6>
          <Button
            size="xs"
            label="Edit "
            className="borderRedBtn"
            onClick={handleAddwaste}
          />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {wasteListItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? "Today" : formatDateAndTime(date, PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div> */}
    </div>
  );
};

export default Processing;
